import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'acan-multiselect',
  templateUrl: './acan-multiselect.component.html',
  styleUrls: ['./acan-multiselect.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AcanMultiselectComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class AcanMultiselectComponent implements ControlValueAccessor {
  @Input() options: unknown[] = [];
  @Input() optionLabel = 'label';
  @Input() optionValue = 'value';
  @Input() placeholder = '';
  @Input() filter = false;
  @Input() display: 'comma' | 'chip' = 'comma';

  value: unknown[] = [];
  disabled = false;

  private onChange: (value: unknown[]) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: unknown[] | null): void {
    this.value = value ?? [];
  }

  registerOnChange(fn: (value: unknown[]) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onValueChange(value: unknown[]): void {
    this.value = value;
    this.onChange(value);
  }

  onBlur(): void {
    this.onTouched();
  }
}
